import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { CaptureService } from 'app/core/services/capture.service';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-verified-invalid-reviewed',
    templateUrl: './verified-invalid-reviewed.component.html',
    styleUrls: ['./verified-invalid-reviewed.component.scss'],
    imports: [NgClass, FormsModule]
})
export class VerifiedInvalidReviewedComponent implements OnInit {
  private captureService = inject(CaptureService);
  private authService = inject(AuthenticationService);

  @Input() capture: Capture;

  enabled = false;
  canManageVerifiedInvalidReviewed = false;

  ngOnInit() {
    this.init();
  }

  onClick() {
    this.enabled = true;
    this.captureService.toggleVerifiedInvalidReviewed(this.capture).subscribe(
      capture => this.enabled = capture.verifiedInvalidReviewed
    );
  }

  private init() {
    this.enabled = this.capture.verifiedInvalidReviewed;
    this.canManageVerifiedInvalidReviewed = this.authService.isCaptureAdminUser;
  }
}
